import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as L from 'leaflet';
import * as esri from 'esri-leaflet';
import Schools from './propertydetail/schools';
import DemoGraphicData from './propertydetail/demographicdata';
import '../css/product_detail.css';
import { convertPolygoneFormat, encodeSearchParams } from './util';
import DocumentTitle from 'react-document-title';
import Loader from 'components/loader';
import { Helmet } from "react-helmet";
import { BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {ImageRewrite, getFormatedCurrency} from './util';
import NoPropertyPhoto from '../img/no-property-photo.png';
import { Label } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {GetMetaTagsProperties, GetSectionCustomizationOptions} from '../components/util';
import ExternalNeighborhoodChart from './neighborhoodcharts/externalneighborhoodchart';
import CustomNeighborhoodChart from './neighborhoodcharts/customneighbourhoodchart';

import * as settingsActions from 'actions/settings';


const MetaTagsProperties = GetMetaTagsProperties();
const CommonCustomizationOptions = GetSectionCustomizationOptions("CommonOptions");

class Neighborhood extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
          name: '', 
          polygon: null, 
          polygonString: '', 
          description: '', 
          zipcode: '', 
          recentSales: 'Listings',
          listingsType: "current",
          stateName: ""
        }
    }

    componentDidMount() {
        if (!this.props.showHeader) {
            this.props.onShowHideHeader(true);
        }
        if (!this.props.showFooter) {
            this.props.onShowHideFooter(true);
        }
        const {params} = this.props.match;
        if (params.name) {
           this.getNeighborhood(params.name);
        }
        this.map = undefined;
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.name !== nextProps.match.params.name) {
            if(this.map){
              try{
                this.map.remove();
              }
              catch(ex){}
            }
            this.getNeighborhood(nextProps.match.params.name);
        }
        if ((this.props.isFNDFetching && !nextProps.isFNDFetching) || JSON.stringify(this.props.featuredNeighborhoodDetail) !== JSON.stringify(nextProps.featuredNeighborhoodDetail)) {
          this.setNeighborhoodDetails(nextProps.featuredNeighborhoodDetail);
        }
    }

    setNeighborhoodDetails = (featuredNeighborhoodDetail) => {
      if(featuredNeighborhoodDetail && featuredNeighborhoodDetail.Id){
        var boundaries = {};
        if(featuredNeighborhoodDetail.PolygonBoundary){
          boundaries.Polygon = JSON.parse(featuredNeighborhoodDetail.PolygonBoundary);
        }        
        if(boundaries && boundaries.Polygon){
          boundaries.Latitude = featuredNeighborhoodDetail.Latitude;
          boundaries.Longitude = featuredNeighborhoodDetail.Longitude;

          this.setState({ 
            neighborhoodObj: featuredNeighborhoodDetail,
            polygon: boundaries.Polygon, 
            description: (featuredNeighborhoodDetail.Description && featuredNeighborhoodDetail.Description !== "") ? featuredNeighborhoodDetail.Description : 
              (featuredNeighborhoodDetail.Discover && featuredNeighborhoodDetail.Discover !== "" ? featuredNeighborhoodDetail.Discover : 
              (featuredNeighborhoodDetail.Spotlight && featuredNeighborhoodDetail.Spotlight !== "" ? featuredNeighborhoodDetail.Spotlight : "")), 
            name: featuredNeighborhoodDetail.Name,
            stateName: featuredNeighborhoodDetail.State,
            listingsType: "current" 
          }, () => {
                this.buildMap(boundaries);
                this.getRecentListings();
          });
        }        
        
      }
    }

    getNeighborhood(name){
        this.props.settingsActions.fetchFeaturedNeighborhoodDetail(name);        
    }

    buildMap(boundaries) {
        var map = L.map('map').setView([boundaries.Latitude, boundaries.Longitude], 13);
        this.map = map;
        var streetsLayer = esri.basemapLayer("Streets");
        streetsLayer.addTo(map);
        var polygon = L.polygon(boundaries.Polygon.map((point, i) => {
            return [point[1], point[0]];
        })).addTo(map);
        map.fitBounds(polygon.getBounds());
    }

    getRecentListings(soldFlag) {
        const { polygon } = this.state;
        var latLngs = [];
        var polygonString = [];
        if (polygon && polygon.length) {
            polygon.forEach((point) => {
                latLngs.push(L.latLng(point[1], point[0]));
            });
            polygonString.push(convertPolygoneFormat(latLngs));
            if (polygonString.length > 0){
                 this.getListings(polygonString, soldFlag);
                 this.setState({polygonString});
            }
        }
    }

    searchArea = () => {
        const { polygonString } = this.state;
        var parameters = { polygon: polygonString };
        var url = `/search/?${ encodeSearchParams(parameters) }`
        this.props.history.push(url);
    }

    getListings = (polygon, soldFlag) => {
        var that = this;
        var requestBody = {
            limitrecords: "10",
            ficoscore: "760-850",
            loantype: "30YrFixed",
            lifestyle: "couple-no-kids",
            orderby: "newest",
            orderbydirection: "DESC",
            skip: 0,
            //propertytype: "sf",
            //baths: "1g",
            //beds: "1g",
            polygon: polygon 
        }
        if(soldFlag) requestBody.status = "Sold";
        if(that.state.name && that.state.name.toLowerCase() === "rochester") requestBody.regionalboardcode = "rochester";
        var url = window.sessionStorage.getItem("RootAPI") + "listingsdata/";

        fetch(url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
            },
            method: "POST",
            body: JSON.stringify(requestBody)
        })
        .then(response => {
            if (response.ok) return response.json()
            else throw Error(response.statusText)
        })
        .then(json => {
            var results = json.Listings;
            var zipcode = '';            
            /* if(soldFlag && results.length === 0){
              this.getRecentListings();
            }
            else{
              if (results.length > 0){
                zipcode = results[0].PC;
              }
              that.setState({ results: results, zipcode: zipcode, fetchingResult: false, recentSales: soldFlag ? "Sales" : "Listings" });              
            } */
            if (results.length > 0){
              zipcode = results[0].PC;
            }
            that.setState({ results: results, zipcode: zipcode, fetchingResult: false, recentSales: soldFlag ? "Sales" : "Listings" });
            
        })
        .catch(function (data) {
            console.log(data);
            that.setState({ results: [], errorMessage: 'Search failed', fetchingResult: false });
        });
    }

    handleListingsTypeChange = (type) => {
      var self = this;
      self.setState({listingsType: type}, () => {
        if(type === "current") self.getRecentListings();
        else self.getRecentListings(true);
      })
    }

    render() {
      
        const { name, description, results, polygonString, zipcode, neighborhoodObj } = this.state;

        const ogTitle = (MetaTagsProperties && MetaTagsProperties.neighbourhood && MetaTagsProperties.neighbourhood.title) ? MetaTagsProperties.neighbourhood.title + name : name;
        const ogDesc = (MetaTagsProperties && MetaTagsProperties.neighbourhood && MetaTagsProperties.neighbourhood.desc) ? MetaTagsProperties.neighbourhood.desc : "";
        const ogImage = (MetaTagsProperties && MetaTagsProperties.neighbourhood && MetaTagsProperties.neighbourhood.img) ? MetaTagsProperties.neighbourhood.img : "";
        const ogUrl = window.location.toString().substr(0);

        return <DocumentTitle title={name}>
          <div>
            <Helmet>
                <meta name="description" content={ogDesc} />
                <meta itemProp="name" content={ogTitle} />
                <meta itemProp="description" content={ogDesc} />
                <meta itemProp="image" content={ogImage} />
                <meta property="og:title" content={ogTitle} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={ogUrl} />
                <meta property="og:image" content={ogImage} />
                <meta property="og:description" content={ogDesc} />
            </Helmet>
            <div className="fluid row">
                <div className="common_content margin-top-20">
                    {!this.props.isFNDFetching && name &&
                        <div>
                            <div className="col-md-12"><h2>{name}</h2></div>
                            <div className="col-md-6">
                                <div className="text-justify">
                                    {description}
                                    <br /><br />
                                </div>
                                <div id="map"></div>                                
                                <br />
                                {zipcode &&
                                  <DemoGraphicData postalcode={zipcode} />
                                }                                
                            </div>
                            <div className="col-md-6 col-xs-12">    
                               
                                {(CommonCustomizationOptions && CommonCustomizationOptions.CustomNeighborhoodChartsUrl && CommonCustomizationOptions.CustomNeighborhoodChartsUrl !== "")
                                  ? <CustomNeighborhoodChart City={this.state.name} State={this.state.stateName}/> 
                                  : <ExternalNeighborhoodChart neighborhoodObj={neighborhoodObj} />
                                }

                                {results &&
                                  <div className="row fluid">
                                    <div className="col-md-12 col-sm-12 col-xs-12 mg-btm-15">
                                      <div className="row">
                                        <div className="col-md-8 col-sm-8 col-xs-12 mb-tru-center">
                                          <div className="row">
                                            {/*<h3>Recent {this.state.recentSales}</h3>*/}
                                            <div className={this.state.listingsType && this.state.listingsType === "current" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.handleListingsTypeChange("current")}>Current Listings</div>
                                            <div className={this.state.listingsType && this.state.listingsType === "sold" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.handleListingsTypeChange("sold")}>Recent Sales</div>                                            
                                          </div>
                                        </div>
                                      <div className="col-md-4 col-sm-4 col-xs-12 text-right mb-tru-center mb-mg-top-15">
                                        <div className="row">
                                          <button className="btn btn-default" ref="btnSubmit" type="button" onClick={this.searchArea}>
                                            <span><i className="fa fa-search"></i> Search Area</span>
                                          </button>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                      <BootstrapTable className={'no-min-width'}
                                          version='4' data={results} striped={true}>
                                          <TableHeaderColumn isKey={true} searchable={false} dataField='Id' hidden>PropID</TableHeaderColumn>
                                          <TableHeaderColumn className='col-md-7' columnClassName='col-md-7' tdStyle={{ whiteSpace: 'normal' }} dataField='Photos' dataFormat={fLink}>Property</TableHeaderColumn>
                                          <TableHeaderColumn className='col-md-2' columnClassName='col-md-2' tdStyle={{ whiteSpace: 'normal' }} dataField='LP' dataFormat={fcField}>Price</TableHeaderColumn>
                                          <TableHeaderColumn className='col-md-1' columnClassName='col-md-1' tdStyle={{ whiteSpace: 'normal' }} dataField='TLC' dataFormat={fcField}>TLC</TableHeaderColumn>
                                          <TableHeaderColumn className='col-md-2' columnClassName='col-md-2' tdStyle={{ whiteSpace: 'normal' }} dataField='SS' dataFormat={fStatus}>Status</TableHeaderColumn>
                                      </BootstrapTable>
                                  </div>
                                }
                                <br />
                                {polygonString &&
                                  <Schools polygon={polygonString} />
                                }                              
                            </div>
                        </div>
                    }
                    {!name && !this.props.isFNDFetching &&
                        <h2 className="text-center">Neighborhood not found</h2>
                    }
                    {this.props.isFNDFetching &&
                      <h2 className="text-center"><Loader message={'Loading neighborhood details...'} /></h2>
                    }
                </div>
            </div>
          </div>
        </DocumentTitle>
    }
}

const mapStateToProps = (state, props) => ({
  featuredNeighborhoodDetail: state.settings.featuredNeighborhoodDetail || {},
  isFNDFetching: state.settings.isFNDFetching || false
});

const mapDispatchToProps = dispatch => ({
  settingsActions: bindActionCreators(settingsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Neighborhood);

// BOOTSTRAP TABLE FORMATS
function fLink(cell, row){
    var imgTitle = "";
    imgTitle = (row.SA && row.SA !== "" ? row.SA + ", " : "") + row.CT + ', ' + row.ST + ' ' + row.PC;
    
    var plink = "/propertydetail/" + row.Id + '/' + (row.SA ? row.SA.split(' ').join('-') : row.MN) + (row.CT ? '_' + row.CT.split(' ').join('-') : '') + (row.ST ? '_' + row.ST.split(' ').join('-') : '') + (row.PC ? '_' + row.PC.split(' ').join('-') : '');
    var imgSrc = NoPropertyPhoto;
    if (row && row.Photos && row.Photos.length > 0) {
        imgSrc = ImageRewrite(row.Photos[0], true);
    }
    return (
        <Link className="suggest_boxlink" to={plink}>
            <div>
                <div className="tbl-imgbox">
                    <div className="tbl-img">
                        <img src={imgSrc} alt={imgTitle} />
                    </div>
                </div>
                {/* <div className="tbl-propbox"> */}
                <div>
                    <div className="tbl-propbox-txt">MLS: {row.MN}</div>
                    <div className="tbl-propbox-txt">{imgTitle}</div>
                    <div className="openhousefacility_list">
                        <div className="star-rating ">
                            <i className="fa fa-bed"></i>{row.BD}
                        </div>
                        <div className="star-rating ">
                            <i className="fa fa-bath"></i>{row.BDI}
                        </div>
                        <div className="star-rating ">
                            <i className="fa fa-car"></i>{row.GR}
                        </div>
                        <div className="star-rating ">
                            <i className="fa fa-arrows-alt"></i>{row.LA} ft
                        </div>                           
                    </div>
                </div>
            </div>
        </Link>
    ) 
}

function fcField(cell, row){
    return getFormatedCurrency(cell);
}

function fStatus(cell, row){
    return <span className="status_suggest"><Label  bsStyle={cell.toString().toLowerCase() === "active" ? "success" : (cell.toString().toLowerCase() === "sold" ? "danger" : "primary")} style={{fontWeight: "normal"}}>{cell}</Label></span>;
}


// TEST DATA
export const Alamo_Heights = 
{
    "Name": "Alamo_Heights",
    "DisplayName": "Alamo Heights",
    "Description": "Alamo Heights is an incorporated city that is surrounded by the city of San Antonio in Bexar County in the U.S. state of Texas. At the time of the 2010 census, the population of Alamo Heights was 7,031.[4] It is part of the Greater San Antonio metropolitan area. A portion of the University of the Incarnate Word is in Alamo Heights. The current mayor of Alamo Heights is The Honorable Bobby Rosenthal.",
    "Image": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/St._Peter%27s_Church%2C_Alamo_Heights%2C_TX.jpg/300px-St._Peter%27s_Church%2C_Alamo_Heights%2C_TX.jpg",
    "Boundaries": [
      {
        "Latitude": 29.4849531,
        "Longitude": -98.4658501,
        "Polygon":[
            [
              -98.482264,
              29.489425
            ],
            [
              -98.482259,
              29.4896862
            ],
            [
              -98.4822479,
              29.4898002
            ],
            [
              -98.4821001,
              29.4904929
            ],
            [
              -98.4819296,
              29.4913465
            ],
            [
              -98.4814439,
              29.4913085
            ],
            [
              -98.4799076,
              29.4913172
            ],
            [
              -98.4796445,
              29.4912936
            ],
            [
              -98.4709128,
              29.491311
            ],
            [
              -98.4686025,
              29.4949516
            ],
            [
              -98.4684321,
              29.4952913
            ],
            [
              -98.4682246,
              29.4952591
            ],
            [
              -98.4666243,
              29.495264
            ],
            [
              -98.4666294,
              29.4961554
            ],
            [
              -98.4593947,
              29.4961589
            ],
            [
              -98.459496,
              29.4957739
            ],
            [
              -98.4594059,
              29.4956466
            ],
            [
              -98.4594066,
              29.494837
            ],
            [
              -98.4594482,
              29.4947082
            ],
            [
              -98.4594058,
              29.4902802
            ],
            [
              -98.4593841,
              29.4900732
            ],
            [
              -98.4593746,
              29.485122
            ],
            [
              -98.4593705,
              29.4844981
            ],
            [
              -98.4593575,
              29.4844506
            ],
            [
              -98.459191,
              29.4844352
            ],
            [
              -98.4591916,
              29.4839586
            ],
            [
              -98.4592296,
              29.483071
            ],
            [
              -98.4592001,
              29.4810673
            ],
            [
              -98.4592,
              29.4800685
            ],
            [
              -98.4591913,
              29.4769719
            ],
            [
              -98.4591997,
              29.4768458
            ],
            [
              -98.4591944,
              29.4755673
            ],
            [
              -98.459207,
              29.4750071
            ],
            [
              -98.4591862,
              29.4748611
            ],
            [
              -98.4591887,
              29.4743996
            ],
            [
              -98.4591899,
              29.4741183
            ],
            [
              -98.4592083,
              29.4737677
            ],
            [
              -98.4592065,
              29.4732617
            ],
            [
              -98.4591978,
              29.4732178
            ],
            [
              -98.4592039,
              29.4729418
            ],
            [
              -98.4594695,
              29.4723258
            ],
            [
              -98.459516,
              29.4721596
            ],
            [
              -98.4598518,
              29.4714189
            ],
            [
              -98.4599272,
              29.4712659
            ],
            [
              -98.4602561,
              29.4697707
            ],
            [
              -98.4603136,
              29.469581
            ],
            [
              -98.4604483,
              29.4689764
            ],
            [
              -98.4604501,
              29.4689094
            ],
            [
              -98.4605868,
              29.4682975
            ],
            [
              -98.4634864,
              29.4682756
            ],
            [
              -98.4637859,
              29.4682133
            ],
            [
              -98.4672161,
              29.4682236
            ],
            [
              -98.4672334,
              29.4682805
            ],
            [
              -98.4673322,
              29.4683386
            ],
            [
              -98.4674618,
              29.4683709
            ],
            [
              -98.4676718,
              29.4684386
            ],
            [
              -98.4679534,
              29.4686203
            ],
            [
              -98.4681967,
              29.4688354
            ],
            [
              -98.4684437,
              29.468945
            ],
            [
              -98.4686537,
              29.4690192
            ],
            [
              -98.4687623,
              29.4690881
            ],
            [
              -98.4688364,
              29.469159
            ],
            [
              -98.4688636,
              29.4692854
            ],
            [
              -98.4688414,
              29.4694655
            ],
            [
              -98.4688364,
              29.4695741
            ],
            [
              -98.468885,
              29.4696778
            ],
            [
              -98.4690021,
              29.4698319
            ],
            [
              -98.4691573,
              29.4700194
            ],
            [
              -98.4691481,
              29.4700882
            ],
            [
              -98.4692147,
              29.4701603
            ],
            [
              -98.4693216,
              29.470213
            ],
            [
              -98.4694185,
              29.47022
            ],
            [
              -98.4696845,
              29.4701912
            ],
            [
              -98.4698022,
              29.4702191
            ],
            [
              -98.4699505,
              29.4703231
            ],
            [
              -98.4702513,
              29.4706254
            ],
            [
              -98.4705398,
              29.4709675
            ],
            [
              -98.4707639,
              29.4712258
            ],
            [
              -98.471006,
              29.4714667
            ],
            [
              -98.4717989,
              29.4721215
            ],
            [
              -98.4719051,
              29.4721709
            ],
            [
              -98.4720731,
              29.4722731
            ],
            [
              -98.4723065,
              29.4723666
            ],
            [
              -98.4728508,
              29.4725863
            ],
            [
              -98.4730646,
              29.4727179
            ],
            [
              -98.473158,
              29.4728829
            ],
            [
              -98.4734696,
              29.4734242
            ],
            [
              -98.473519,
              29.4736081
            ],
            [
              -98.4735721,
              29.4739134
            ],
            [
              -98.4735783,
              29.4741521
            ],
            [
              -98.4735437,
              29.4743672
            ],
            [
              -98.4733239,
              29.4748929
            ],
            [
              -98.4732485,
              29.4751176
            ],
            [
              -98.4732103,
              29.4753058
            ],
            [
              -98.4732325,
              29.4754993
            ],
            [
              -98.4733177,
              29.4756585
            ],
            [
              -98.4734116,
              29.4755864
            ],
            [
              -98.4736154,
              29.4758101
            ],
            [
              -98.4740328,
              29.4761896
            ],
            [
              -98.4742218,
              29.4763046
            ],
            [
              -98.4743749,
              29.4764057
            ],
            [
              -98.4744861,
              29.4766046
            ],
            [
              -98.47457,
              29.4768938
            ],
            [
              -98.474659,
              29.4770616
            ],
            [
              -98.4748442,
              29.4771884
            ],
            [
              -98.4750492,
              29.477254
            ],
            [
              -98.4752901,
              29.4772626
            ],
            [
              -98.4754346,
              29.4773099
            ],
            [
              -98.4755482,
              29.4774121
            ],
            [
              -98.4755976,
              29.4775712
            ],
            [
              -98.4756223,
              29.4777948
            ],
            [
              -98.4755754,
              29.478098
            ],
            [
              -98.4755667,
              29.4782722
            ],
            [
              -98.475605,
              29.4784926
            ],
            [
              -98.4756853,
              29.4787012
            ],
            [
              -98.4758668,
              29.4789689
            ],
            [
              -98.4760558,
              29.4792205
            ],
            [
              -98.4764918,
              29.4796011
            ],
            [
              -98.4768332,
              29.4798148
            ],
            [
              -98.4771328,
              29.4799493
            ],
            [
              -98.4773581,
              29.4799858
            ],
            [
              -98.4780368,
              29.4799839
            ],
            [
              -98.4787538,
              29.479893
            ],
            [
              -98.479044,
              29.4798941
            ],
            [
              -98.4792057,
              29.4799193
            ],
            [
              -98.4792058,
              29.4827831
            ],
            [
              -98.47926,
              29.4837189
            ],
            [
              -98.4792757,
              29.4838497
            ],
            [
              -98.4793054,
              29.4839812
            ],
            [
              -98.4793648,
              29.4841226
            ],
            [
              -98.4794364,
              29.4842412
            ],
            [
              -98.4795333,
              29.4843674
            ],
            [
              -98.4796617,
              29.4844852
            ],
            [
              -98.4798494,
              29.4846046
            ],
            [
              -98.4801988,
              29.4847976
            ],
            [
              -98.480514,
              29.4849276
            ],
            [
              -98.480652,
              29.4849938
            ],
            [
              -98.4808153,
              29.4850949
            ],
            [
              -98.480942,
              29.485212
            ],
            [
              -98.4810441,
              29.4853336
            ],
            [
              -98.4811184,
              29.4854545
            ],
            [
              -98.4811991,
              29.4856669
            ],
            [
              -98.4816983,
              29.4875544
            ],
            [
              -98.4817576,
              29.4879619
            ],
            [
              -98.4820651,
              29.4886037
            ],
            [
              -98.4821689,
              29.4888778
            ],
            [
              -98.4822208,
              29.4890864
            ],
            [
              -98.482264,
              29.489425
            ]
          ], 
      }
    ]
  }

export const Universal_City = 
  {
      "Name": "Universal_City",
      "DisplayName": "Universal City",
      "Description": "Universal City is a city in Bexar County, Texas, United States. It borders San Antonio to the northeast, and is adjacent to Randolph Air Force Base. The population was 18,530 at the 2010 census",
      "Image": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Randolph_Air_Force_Base_Chapel.jpg/1200px-Randolph_Air_Force_Base_Chapel.jpg",
      "Boundaries": [
          {
              "Latitude": 29.5480071,
              "Longitude": -98.2911234,
              "Polygon": [
                  [
                      -98.3311245,
                      29.538591
                  ],
                  [
                      -98.3299808,
                      29.5391834
                  ],
                  [
                      -98.3298727,
                      29.5392323
                  ],
                  [
                      -98.3298208,
                      29.5395995
                  ],
                  [
                      -98.3286408,
                      29.5399787
                  ],
                  [
                      -98.3276253,
                      29.5405004
                  ],
                  [
                      -98.3269586,
                      29.5408685
                  ],
                  [
                      -98.327985,
                      29.543243
                  ],
                  [
                      -98.3263287,
                      29.5439656
                  ],
                  [
                      -98.322624,
                      29.5459089
                  ],
                  [
                      -98.3192172,
                      29.5476879
                  ],
                  [
                      -98.3207401,
                      29.550012
                  ],
                  [
                      -98.3230222,
                      29.5533946
                  ],
                  [
                      -98.3270098,
                      29.559324
                  ],
                  [
                      -98.328733,
                      29.5618202
                  ],
                  [
                      -98.3233742,
                      29.564477
                  ],
                  [
                      -98.3231102,
                      29.5649051
                  ],
                  [
                      -98.3235111,
                      29.5651609
                  ],
                  [
                      -98.323778,
                      29.565388
                  ],
                  [
                      -98.3241092,
                      29.5657917
                  ],
                  [
                      -98.3256207,
                      29.5680162
                  ],
                  [
                      -98.3259364,
                      29.5684351
                  ],
                  [
                      -98.3219897,
                      29.5704752
                  ],
                  [
                      -98.3213669,
                      29.5695162
                  ],
                  [
                      -98.3201796,
                      29.5701022
                  ],
                  [
                      -98.3204491,
                      29.5704874
                  ],
                  [
                      -98.3198954,
                      29.5713696
                  ],
                  [
                      -98.3186998,
                      29.5709213
                  ],
                  [
                      -98.3177995,
                      29.5716206
                  ],
                  [
                      -98.3172001,
                      29.572706
                  ],
                  [
                      -98.3171389,
                      29.573048
                  ],
                  [
                      -98.3168102,
                      29.572975
                  ],
                  [
                      -98.3158822,
                      29.572685
                  ],
                  [
                      -98.3158238,
                      29.5728124
                  ],
                  [
                      -98.3155247,
                      29.5732991
                  ],
                  [
                      -98.315333,
                      29.5734775
                  ],
                  [
                      -98.3152334,
                      29.5738514
                  ],
                  [
                      -98.314951,
                      29.5739605
                  ],
                  [
                      -98.3149195,
                      29.5745945
                  ],
                  [
                      -98.3148165,
                      29.5746942
                  ],
                  [
                      -98.3146381,
                      29.5744416
                  ],
                  [
                      -98.3139878,
                      29.5747446
                  ],
                  [
                      -98.3143153,
                      29.5752228
                  ],
                  [
                      -98.3137061,
                      29.5755325
                  ],
                  [
                      -98.3120162,
                      29.576402
                  ],
                  [
                      -98.3134501,
                      29.5787169
                  ],
                  [
                      -98.3127539,
                      29.5789972
                  ],
                  [
                      -98.3136829,
                      29.5796583
                  ],
                  [
                      -98.3125839,
                      29.5800741
                  ],
                  [
                      -98.3122688,
                      29.5797277
                  ],
                  [
                      -98.3119544,
                      29.578777
                  ],
                  [
                      -98.3113719,
                      29.5790118
                  ],
                  [
                      -98.3109427,
                      29.5781526
                  ],
                  [
                      -98.3103105,
                      29.5774081
                  ],
                  [
                      -98.3101565,
                      29.5771529
                  ],
                  [
                      -98.3100886,
                      29.5766929
                  ],
                  [
                      -98.3097258,
                      29.5758418
                  ],
                  [
                      -98.3096668,
                      29.5754402
                  ],
                  [
                      -98.3095434,
                      29.5751743
                  ],
                  [
                      -98.3082567,
                      29.5748055
                  ],
                  [
                      -98.307757,
                      29.5743871
                  ],
                  [
                      -98.3074369,
                      29.5738639
                  ],
                  [
                      -98.3066183,
                      29.573036
                  ],
                  [
                      -98.3060509,
                      29.573266
                  ],
                  [
                      -98.3047247,
                      29.5739369
                  ],
                  [
                      -98.3039247,
                      29.5743794
                  ],
                  [
                      -98.3029458,
                      29.5747977
                  ],
                  [
                      -98.3028892,
                      29.5746392
                  ],
                  [
                      -98.302742,
                      29.573479
                  ],
                  [
                      -98.3026422,
                      29.5731265
                  ],
                  [
                      -98.3029057,
                      29.5724175
                  ],
                  [
                      -98.3029193,
                      29.5718798
                  ],
                  [
                      -98.3026604,
                      29.5705677
                  ],
                  [
                      -98.3025272,
                      29.5699253
                  ],
                  [
                      -98.3022921,
                      29.5693924
                  ],
                  [
                      -98.3020637,
                      29.5690479
                  ],
                  [
                      -98.3019379,
                      29.568828
                  ],
                  [
                      -98.3015389,
                      29.568342
                  ],
                  [
                      -98.3011839,
                      29.568029
                  ],
                  [
                      -98.3008689,
                      29.567743
                  ],
                  [
                      -98.3004169,
                      29.567372
                  ],
                  [
                      -98.3000839,
                      29.567099
                  ],
                  [
                      -98.2998999,
                      29.566918
                  ],
                  [
                      -98.2998499,
                      29.566868
                  ],
                  [
                      -98.2994599,
                      29.56641
                  ],
                  [
                      -98.2990999,
                      29.565767
                  ],
                  [
                      -98.2990219,
                      29.565425
                  ],
                  [
                      -98.2989479,
                      29.565098
                  ],
                  [
                      -98.2986389,
                      29.564202
                  ],
                  [
                      -98.2986499,
                      29.564062
                  ],
                  [
                      -98.2985669,
                      29.563974
                  ],
                  [
                      -98.2985609,
                      29.563825
                  ],
                  [
                      -98.2983969,
                      29.563577
                  ],
                  [
                      -98.2983279,
                      29.56322
                  ],
                  [
                      -98.2984729,
                      29.562994
                  ],
                  [
                      -98.2984609,
                      29.562846
                  ],
                  [
                      -98.2983969,
                      29.56262
                  ],
                  [
                      -98.2985799,
                      29.562187
                  ],
                  [
                      -98.2986299,
                      29.561917
                  ],
                  [
                      -98.2985919,
                      29.56173
                  ],
                  [
                      -98.2985889,
                      29.561685
                  ],
                  [
                      -98.2985869,
                      29.561658
                  ],
                  [
                      -98.2985919,
                      29.561504
                  ],
                  [
                      -98.2985609,
                      29.561372
                  ],
                  [
                      -98.2985359,
                      29.561168
                  ],
                  [
                      -98.2985239,
                      29.561141
                  ],
                  [
                      -98.2982469,
                      29.561113
                  ],
                  [
                      -98.2980769,
                      29.561118
                  ],
                  [
                      -98.2980209,
                      29.561102
                  ],
                  [
                      -98.2979509,
                      29.561052
                  ],
                  [
                      -98.2978819,
                      29.560986
                  ],
                  [
                      -98.2978499,
                      29.560932
                  ],
                  [
                      -98.2977869,
                      29.560877
                  ],
                  [
                      -98.2976989,
                      29.56086
                  ],
                  [
                      -98.2975789,
                      29.560855
                  ],
                  [
                      -98.2973969,
                      29.56081
                  ],
                  [
                      -98.2973399,
                      29.560821
                  ],
                  [
                      -98.2973209,
                      29.560843
                  ],
                  [
                      -98.2971419,
                      29.560925
                  ],
                  [
                      -98.2970069,
                      29.560924
                  ],
                  [
                      -98.2968189,
                      29.560889
                  ],
                  [
                      -98.2968049,
                      29.560822
                  ],
                  [
                      -98.2967229,
                      29.560727
                  ],
                  [
                      -98.2966609,
                      29.560723
                  ],
                  [
                      -98.2965669,
                      29.560734
                  ],
                  [
                      -98.2964909,
                      29.560794
                  ],
                  [
                      -98.2964219,
                      29.560882
                  ],
                  [
                      -98.2963089,
                      29.56097
                  ],
                  [
                      -98.2958739,
                      29.561013
                  ],
                  [
                      -98.2957169,
                      29.561052
                  ],
                  [
                      -98.2956099,
                      29.561163
                  ],
                  [
                      -98.2953019,
                      29.561234
                  ],
                  [
                      -98.2951659,
                      29.561282
                  ],
                  [
                      -98.2950549,
                      29.561321
                  ],
                  [
                      -98.2950049,
                      29.561393
                  ],
                  [
                      -98.2949419,
                      29.561448
                  ],
                  [
                      -98.2947654,
                      29.5616778
                  ],
                  [
                      -98.2946929,
                      29.5617028
                  ],
                  [
                      -98.2946229,
                      29.5616978
                  ],
                  [
                      -98.2945609,
                      29.5616758
                  ],
                  [
                      -98.2942089,
                      29.5616418
                  ],
                  [
                      -98.2940549,
                      29.5616278
                  ],
                  [
                      -98.2938369,
                      29.5616088
                  ],
                  [
                      -98.2935799,
                      29.5615868
                  ],
                  [
                      -98.2933019,
                      29.5615428
                  ],
                  [
                      -98.2928779,
                      29.5614538
                  ],
                  [
                      -98.2923839,
                      29.5612298
                  ],
                  [
                      -98.2921809,
                      29.5612428
                  ],
                  [
                      -98.2918509,
                      29.5611488
                  ],
                  [
                      -98.2915609,
                      29.5610668
                  ],
                  [
                      -98.2914119,
                      29.5610648
                  ],
                  [
                      -98.2913219,
                      29.5610628
                  ],
                  [
                      -98.2911929,
                      29.5609768
                  ],
                  [
                      -98.2905459,
                      29.5607828
                  ],
                  [
                      -98.2905149,
                      29.5607718
                  ],
                  [
                      -98.2904709,
                      29.5607008
                  ],
                  [
                      -98.2904329,
                      29.5604918
                  ],
                  [
                      -98.2901059,
                      29.5603268
                  ],
                  [
                      -98.2899499,
                      29.5602838
                  ],
                  [
                      -98.2893509,
                      29.5600768
                  ],
                  [
                      -98.2889429,
                      29.5599358
                  ],
                  [
                      -98.2887789,
                      29.5598858
                  ],
                  [
                      -98.2885149,
                      29.5598808
                  ],
                  [
                      -98.2882249,
                      29.5597378
                  ],
                  [
                      -98.2878409,
                      29.5595178
                  ],
                  [
                      -98.2877909,
                      29.5594738
                  ],
                  [
                      -98.2873449,
                      29.5590938
                  ],
                  [
                      -98.2872159,
                      29.5589838
                  ],
                  [
                      -98.2868299,
                      29.5586548
                  ],
                  [
                      -98.2860599,
                      29.5577788
                  ],
                  [
                      -98.2860479,
                      29.5576358
                  ],
                  [
                      -98.2857709,
                      29.5574648
                  ],
                  [
                      -98.2856839,
                      29.5572898
                  ],
                  [
                      -98.2856009,
                      29.5569818
                  ],
                  [
                      -98.2855769,
                      29.5568498
                  ],
                  [
                      -98.2856009,
                      29.5567058
                  ],
                  [
                      -98.2857459,
                      29.5565798
                  ],
                  [
                      -98.2858349,
                      29.5565188
                  ],
                  [
                      -98.2858539,
                      29.5564138
                  ],
                  [
                      -98.2858409,
                      29.5562218
                  ],
                  [
                      -98.2858539,
                      29.5561228
                  ],
                  [
                      -98.2857909,
                      29.5558868
                  ],
                  [
                      -98.2857649,
                      29.5556778
                  ],
                  [
                      -98.2856089,
                      29.5552208
                  ],
                  [
                      -98.2855889,
                      29.5549078
                  ],
                  [
                      -98.2854319,
                      29.5547528
                  ],
                  [
                      -98.2853249,
                      29.5546318
                  ],
                  [
                      -98.2852669,
                      29.5545188
                  ],
                  [
                      -98.2851299,
                      29.5542518
                  ],
                  [
                      -98.2848979,
                      29.5540078
                  ],
                  [
                      -98.2847959,
                      29.5539008
                  ],
                  [
                      -98.2847459,
                      29.5538238
                  ],
                  [
                      -98.2845889,
                      29.5537578
                  ],
                  [
                      -98.2843879,
                      29.5535098
                  ],
                  [
                      -98.2842369,
                      29.5533998
                  ],
                  [
                      -98.2840739,
                      29.5533768
                  ],
                  [
                      -98.2839919,
                      29.5533328
                  ],
                  [
                      -98.2836579,
                      29.5532898
                  ],
                  [
                      -98.2831609,
                      29.5530348
                  ],
                  [
                      -98.2828409,
                      29.5529638
                  ],
                  [
                      -98.2824189,
                      29.5527778
                  ],
                  [
                      -98.2819599,
                      29.5525068
                  ],
                  [
                      -98.2815759,
                      29.5523038
                  ],
                  [
                      -98.2808399,
                      29.5519848
                  ],
                  [
                      -98.2807759,
                      29.5519458
                  ],
                  [
                      -98.2804359,
                      29.5518368
                  ],
                  [
                      -98.2796389,
                      29.5515108
                  ],
                  [
                      -98.2791279,
                      29.5512858
                  ],
                  [
                      -98.2788399,
                      29.5512628
                  ],
                  [
                      -98.2788329,
                      29.5512908
                  ],
                  [
                      -98.2787889,
                      29.5513238
                  ],
                  [
                      -98.2786949,
                      29.5513458
                  ],
                  [
                      -98.2784809,
                      29.5513458
                  ],
                  [
                      -98.2778459,
                      29.5513898
                  ],
                  [
                      -98.2775369,
                      29.5513898
                  ],
                  [
                      -98.2770969,
                      29.5513238
                  ],
                  [
                      -98.276873,
                      29.5512108
                  ],
                  [
                      -98.276192,
                      29.5512457
                  ],
                  [
                      -98.2752878,
                      29.5512928
                  ],
                  [
                      -98.2742917,
                      29.5513213
                  ],
                  [
                      -98.2736446,
                      29.5512168
                  ],
                  [
                      -98.273389,
                      29.5511361
                  ],
                  [
                      -98.2727789,
                      29.5508516
                  ],
                  [
                      -98.2764417,
                      29.549148
                  ],
                  [
                      -98.2764234,
                      29.5491103
                  ],
                  [
                      -98.2815957,
                      29.5467131
                  ],
                  [
                      -98.2824243,
                      29.5462798
                  ],
                  [
                      -98.2831165,
                      29.5459584
                  ],
                  [
                      -98.2872323,
                      29.5440476
                  ],
                  [
                      -98.2887687,
                      29.5433216
                  ],
                  [
                      -98.2914021,
                      29.5422037
                  ],
                  [
                      -98.2932931,
                      29.5413432
                  ],
                  [
                      -98.294532,
                      29.5406499
                  ],
                  [
                      -98.2954652,
                      29.5399855
                  ],
                  [
                      -98.2962646,
                      29.5392918
                  ],
                  [
                      -98.2970586,
                      29.538433
                  ],
                  [
                      -98.2987882,
                      29.5363136
                  ],
                  [
                      -98.3008737,
                      29.5337328
                  ],
                  [
                      -98.3009619,
                      29.5339
                  ],
                  [
                      -98.3011154,
                      29.5340098
                  ],
                  [
                      -98.3049271,
                      29.5293615
                  ],
                  [
                      -98.305348,
                      29.5295121
                  ],
                  [
                      -98.3080912,
                      29.5262154
                  ],
                  [
                      -98.3081887,
                      29.5261169
                  ],
                  [
                      -98.3154273,
                      29.5367426
                  ],
                  [
                      -98.3211221,
                      29.5337613
                  ],
                  [
                      -98.3218115,
                      29.5332841
                  ],
                  [
                      -98.3221956,
                      29.5329369
                  ],
                  [
                      -98.3229306,
                      29.5324166
                  ],
                  [
                      -98.3234335,
                      29.5327162
                  ],
                  [
                      -98.3238598,
                      29.5329481
                  ],
                  [
                      -98.3241752,
                      29.5331846
                  ],
                  [
                      -98.3255392,
                      29.5350564
                  ],
                  [
                      -98.3258171,
                      29.535444
                  ],
                  [
                      -98.3259618,
                      29.5356142
                  ],
                  [
                      -98.3261818,
                      29.5357812
                  ],
                  [
                      -98.3288322,
                      29.537302
                  ],
                  [
                      -98.3311245,
                      29.538591
                  ]
              ]
          }
      ]
  }

  export const Buffalo_City = 
  {
      "Name": "Buffalo_City",
      "DisplayName": "Buffalo",
      "Description": "Buffalo is a city on the shores of Lake Erie in upstate New York. Its fine neoclassical, beaux arts and art deco architecture speaks to its history as an industrial capital in the early 20th century. Its landmarks include the 398-ft art deco City Hall, the Frank Lloyd Wright–designed Darwin D. Martin House and the Albright-Knox Art Gallery, a Greek Revival museum with works by Picasso and Warhol.",
      "Image": "https://upload.wikimedia.org/wikipedia/en/thumb/6/63/Aerial_photo_of_Buffalo%2C_NY_Skyline.jpg/1920px-Aerial_photo_of_Buffalo%2C_NY_Skyline.jpg",
      "Boundaries": [
          {
              "Latitude": 42.8845178,
              "Longitude": -78.8759995,
              "Polygon": [
                [
                    -78.9134216,
                    42.9561712
                  ],
                  [
                    -78.8990021,
                    42.96597
                  ],
                  [
                    -78.8862991,
                    42.9579301
                  ],
                  [
                    -78.804245,
                    42.9581814
                  ],
                  [
                    -78.8028717,
                    42.8208398
                  ],
                  [
                    -78.8598633,
                    42.8291494
                  ],
                  [
                    -78.8900757,
                    42.8757125
                  ],
                  [
                    -78.8921356,
                    42.8862787
                  ],
                  [
                    -78.902092,
                    42.895334
                  ],
                  [
                    -78.9089584,
                    42.9345583
                  ],
                  [
                    -78.913765,
                    42.95592
                  ]
              ]
          }
      ]
  }

  export const Rochester_City = 
  {
      "Name": "Rochester_City",
      "DisplayName": "Rochester",
      "Description": "Rochester is a city on Lake Ontario, in New York State. Old industrial buildings cluster near the Genesee River’s High Falls. A vast collection of toys and dolls forms the core of the Strong National Museum of Play. The George Eastman Museum, on the early-1900s estate of the Kodak founder, has photography exhibits, film archives and gardens. Rochester Museum & Science Center has hands-on displays and a planetarium.",
      "Image": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Rush_Rhees_Library_%288695462255%29.jpg/1024px-Rush_Rhees_Library_%288695462255%29.jpg",
      "Boundaries": [
          {
              "Latitude": 43.1563575,
              "Longitude": -77.6087952,
              "Polygon": [
                [
                    -77.6335144,
                    43.2729559
                  ],
                  [
                    -77.6348877,
                    43.2692062
                  ],
                  [
                    -77.6293945,
                    43.2609561
                  ],
                  [
                    -77.6273346,
                    43.2549553
                  ],
                  [
                    -77.6311111,
                    43.2417014
                  ],
                  [
                    -77.6685333,
                    43.2046753
                  ],
                  [
                    -77.6688766,
                    43.1786435
                  ],
                  [
                    -77.6846695,
                    43.1778924
                  ],
                  [
                    -77.6839828,
                    43.1703811
                  ],
                  [
                    -77.6750565,
                    43.1618672
                  ],
                  [
                    -77.6699066,
                    43.1415791
                  ],
                  [
                    -77.6572037,
                    43.1310568
                  ],
                  [
                    -77.6451874,
                    43.1235397
                  ],
                  [
                    -77.6541138,
                    43.1175253
                  ],
                  [
                    -77.656517,
                    43.1197808
                  ],
                  [
                    -77.6551437,
                    43.1235397
                  ],
                  [
                    -77.6626968,
                    43.1303051
                  ],
                  [
                    -77.6874161,
                    43.1310568
                  ],
                  [
                    -77.6843262,
                    43.1185278
                  ],
                  [
                    -77.6918793,
                    43.1062469
                  ],
                  [
                    -77.6805496,
                    43.1044923
                  ],
                  [
                    -77.6719666,
                    43.1110091
                  ],
                  [
                    -77.6613235,
                    43.1152698
                  ],
                  [
                    -77.658577,
                    43.1135155
                  ],
                  [
                    -77.6633835,
                    43.1085027
                  ],
                  [
                    -77.6616669,
                    43.1017349
                  ],
                  [
                    -77.6486206,
                    43.1014842
                  ],
                  [
                    -77.6455307,
                    43.1080014
                  ],
                  [
                    -77.6475906,
                    43.1127636
                  ],
                  [
                    -77.6376343,
                    43.1140167
                  ],
                  [
                    -77.6345444,
                    43.1170241
                  ],
                  [
                    -77.6122284,
                    43.1085027
                  ],
                  [
                    -77.5971222,
                    43.129804
                  ],
                  [
                    -77.5864792,
                    43.1343139
                  ],
                  [
                    -77.5758362,
                    43.1355666
                  ],
                  [
                    -77.5494003,
                    43.1368192
                  ],
                  [
                    -77.5456238,
                    43.1470901
                  ],
                  [
                    -77.5301743,
                    43.174888
                  ],
                  [
                    -77.5349808,
                    43.1766406
                  ],
                  [
                    -77.5397873,
                    43.1716331
                  ],
                  [
                    -77.5597,
                    43.1713827
                  ],
                  [
                    -77.5579834,
                    43.1766406
                  ],
                  [
                    -77.5603867,
                    43.1899086
                  ],
                  [
                    -77.5466537,
                    43.1911602
                  ],
                  [
                    -77.5346375,
                    43.196917
                  ],
                  [
                    -77.5336075,
                    43.2011717
                  ],
                  [
                    -77.5377274,
                    43.2016722
                  ],
                  [
                    -77.5401306,
                    43.1964164
                  ],
                  [
                    -77.5466537,
                    43.1934129
                  ],
                  [
                    -77.5579834,
                    43.1921614
                  ],
                  [
                    -77.5610733,
                    43.192662
                  ],
                  [
                    -77.5614166,
                    43.2071778
                  ],
                  [
                    -77.5559235,
                    43.216436
                  ],
                  [
                    -77.5476837,
                    43.2266935
                  ],
                  [
                    -77.5538635,
                    43.2319467
                  ],
                  [
                    -77.5559235,
                    43.2356987
                  ],
                  [
                    -77.5816727,
                    43.2434521
                  ],
                  [
                    -77.5888824,
                    43.232447
                  ],
                  [
                    -77.5806427,
                    43.228945
                  ],
                  [
                    -77.5868225,
                    43.2211897
                  ],
                  [
                    -77.5710297,
                    43.2179372
                  ],
                  [
                    -77.569313,
                    43.2251926
                  ],
                  [
                    -77.5590134,
                    43.2246922
                  ],
                  [
                    -77.5545502,
                    43.2241919
                  ],
                  [
                    -77.5542068,
                    43.227444
                  ],
                  [
                    -77.5518036,
                    43.2259431
                  ],
                  [
                    -77.5555801,
                    43.2196886
                  ],
                  [
                    -77.5603867,
                    43.2139339
                  ],
                  [
                    -77.5641632,
                    43.2091797
                  ],
                  [
                    -77.5641632,
                    43.1921614
                  ],
                  [
                    -77.5772095,
                    43.1931626
                  ],
                  [
                    -77.5782394,
                    43.1976678
                  ],
                  [
                    -77.5933456,
                    43.195165
                  ],
                  [
                    -77.6077652,
                    43.1946644
                  ],
                  [
                    -77.6108551,
                    43.1949147
                  ],
                  [
                    -77.614975,
                    43.1956656
                  ],
                  [
                    -77.6166916,
                    43.1984187
                  ],
                  [
                    -77.6204681,
                    43.2064271
                  ],
                  [
                    -77.6084518,
                    43.2194384
                  ],
                  [
                    -77.6111984,
                    43.2329473
                  ],
                  [
                    -77.6091385,
                    43.2469533
                  ],
                  [
                    -77.6005554,
                    43.2549553
                  ],
                  [
                    -77.6338577,
                    43.2732059
                  ]
              ]
          }
      ]
  }

  export const Syracuse_City = 
  {
      "Name": "Syracuse_City",
      "DisplayName": "Syracuse",
      "Description": "Syracuse is a city in New York State. It’s home to the Erie Canal Museum, tracing the waterway’s history in the 1850 Weighlock Building. In the old state armory, the Milton J. Rubenstein Museum of Science & Technology (MOST) offers interactive exhibits and a planetarium. Designed by I.M. Pei, the Everson Museum of Art focuses on American artwork. The opulent 1920s Landmark Theatre hosts Broadway hits and concerts.",
      "Image": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Syracuse_NY.jpg/1024px-Syracuse_NY.jpg",
      "Boundaries": [
          {
              "Latitude": 42.8845178,
              "Longitude": -78.8759995,
              "Polygon": [
                [
                    -76.1791992,
                    43.0786685
                  ],
                  [
                    -76.1764526,
                    43.0829315
                  ],
                  [
                    -76.1682129,
                    43.0801731
                  ],
                  [
                    -76.164093,
                    43.0861911
                  ],
                  [
                    -76.1531067,
                    43.0814269
                  ],
                  [
                    -76.1489868,
                    43.0856897
                  ],
                  [
                    -76.143837,
                    43.0859404
                  ],
                  [
                    -76.1424637,
                    43.0816777
                  ],
                  [
                    -76.133194,
                    43.078167
                  ],
                  [
                    -76.1235809,
                    43.0794208
                  ],
                  [
                    -76.1232376,
                    43.0726498
                  ],
                  [
                    -76.111908,
                    43.0731514
                  ],
                  [
                    -76.1115646,
                    43.0761608
                  ],
                  [
                    -76.0988617,
                    43.07591
                  ],
                  [
                    -76.0827255,
                    43.0533357
                  ],
                  [
                    -76.0913086,
                    43.0510778
                  ],
                  [
                    -76.0947418,
                    43.0470635
                  ],
                  [
                    -76.0909653,
                    43.0435509
                  ],
                  [
                    -76.0820389,
                    43.0385324
                  ],
                  [
                    -76.0861588,
                    43.036274
                  ],
                  [
                    -76.0926819,
                    43.0357721
                  ],
                  [
                    -76.0933685,
                    43.0320078
                  ],
                  [
                    -76.1105347,
                    43.0267374
                  ],
                  [
                    -76.110878,
                    43.0212156
                  ],
                  [
                    -76.1129379,
                    43.0146892
                  ],
                  [
                    -76.121521,
                    43.0139361
                  ],
                  [
                    -76.1256409,
                    42.9863162
                  ],
                  [
                    -76.1431503,
                    42.9845581
                  ],
                  [
                    -76.1627197,
                    42.9825489
                  ],
                  [
                    -76.163063,
                    43.0038939
                  ],
                  [
                    -76.1565399,
                    43.0021364
                  ],
                  [
                    -76.1599731,
                    43.0089152
                  ],
                  [
                    -76.164093,
                    43.013183
                  ],
                  [
                    -76.185379,
                    43.0254825
                  ],
                  [
                    -76.1936188,
                    43.0254825
                  ],
                  [
                    -76.1953354,
                    43.0217176
                  ],
                  [
                    -76.2046051,
                    43.0214666
                  ],
                  [
                    -76.2049484,
                    43.0272394
                  ],
                  [
                    -76.1973953,
                    43.0282433
                  ],
                  [
                    -76.1973953,
                    43.0347683
                  ],
                  [
                    -76.1888123,
                    43.036023
                  ],
                  [
                    -76.1908722,
                    43.0420454
                  ],
                  [
                    -76.1901855,
                    43.0453072
                  ],
                  [
                    -76.1932755,
                    43.0493216
                  ],
                  [
                    -76.1991119,
                    43.045809
                  ],
                  [
                    -76.2080383,
                    43.045809
                  ],
                  [
                    -76.2083817,
                    43.0490707
                  ],
                  [
                    -76.2032318,
                    43.0495725
                  ],
                  [
                    -76.2015152,
                    43.0478162
                  ],
                  [
                    -76.1977386,
                    43.0500742
                  ],
                  [
                    -76.1956787,
                    43.0523322
                  ],
                  [
                    -76.2004852,
                    43.0538374
                  ],
                  [
                    -76.2018585,
                    43.059858
                  ],
                  [
                    -76.1991119,
                    43.0671321
                  ],
                  [
                    -76.1894989,
                    43.0633697
                  ],
                  [
                    -76.1812592,
                    43.0631189
                  ],
                  [
                    -76.1771393,
                    43.068637
                  ],
                  [
                    -76.176796,
                    43.0744053
                  ],
                  [
                    -76.1795425,
                    43.0789193
                  ]
              ]
          }
      ]
  }